// Actions
import {
  SET_AMERICAN_INDIAN_OR_ALASKA_NATIVE,
  SET_ASIAN,
  SET_BLACK_OR_AFRICAN_AMERICAN,
  SET_HISPANIC_OR_LATIN,
  SET_NATIVE_HAWAIIAN_OR_OTHER_PACIFIC_ISLANDER,
  SET_WHITE,
  SET_MIXED_RACE,
  SET_OTHER,
  SET_ETHNICITY_STATE
} from "../actionTypes/ethnicity.actionTypes";

// Classes
import { EthnicityReducerState } from "../classes/ethnicity.classes";

const initialState = new EthnicityReducerState();

export const EthnicityReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case SET_AMERICAN_INDIAN_OR_ALASKA_NATIVE:
      return { ...state, americanIndianOrAlaskaNative: action.payload };
    case SET_ASIAN:
      return { ...state, asian: action.payload };
    case SET_BLACK_OR_AFRICAN_AMERICAN:
      return { ...state, blackOrAfricanAmerican: action.payload };
    case SET_HISPANIC_OR_LATIN:
      return { ...state, hispanicOrLatin: action.payload };
    case SET_NATIVE_HAWAIIAN_OR_OTHER_PACIFIC_ISLANDER:
      return { ...state, nativeHawaiianOrOtherPacificIslander: action.payload };
    case SET_WHITE:
      return { ...state, white: action.payload };
    case SET_MIXED_RACE:
      return { ...state, mixedRace: action.payload };
    case SET_OTHER:
      return { ...state, other: action.payload };
    case SET_ETHNICITY_STATE:
      return { ...state, ...action.payload };
    default:
      return state;
  }
};
